export const Props = (props = {}) => ({
    url: props.url
});
export const validate = () => true;
export const fix = (props, styles) => props;
export const label = 'Graphic';
export const type = 'graphic';
export const category = 'basic';
export const forms = [
    {
        id: 'graphic',
        label: 'Graphic',
        extractProperties: (props) => props,
        validate: () => true
    }
];
//# sourceMappingURL=graphic.js.map